

class Alert {
  /*    
    type = one of these ["info","success","warning","error"]

    timeout -> in miliseconds, if is -1 is permanent until the close button is used
  */
  constructor(text, type = 'info' ,timeout = -1) {
    this._text = text;
    this._type = type;
    this._timeout = timeout;
  }

  copy() {
    return this._text;
  }

  timeout() {
    return this._timeout || -1;
  }

  type() {
    return this._type || 'info';
  }

  toString() {
    return this._text;
  }
}


class NetworkErrorAlert extends Alert {

  constructor(request) {
    let request_data = request.response.data;

    let message = "Error";
    let type = "error";
    if (typeof(request_data) == 'object') {
      message = request_data.message;
      type = request_data.type || "error";
    } else {
      message = request.toString();
    }

    super(message,type,-1);
    this._raw = request.response;
  }

  copy() {
    // Copy only what is necessary
    // Just copy this properties
    /*
    {
      data,
      status,
      config: {
        params,
        url
      }
    }*/
    let props = (({ data, status }) => ({ data, status }))(this._raw);
    let config_data = (({ params, url }) => ({ params, url }))(this._raw.config);
    let result = {...props, ...config_data}
    // Stringify like this to get the string as the json structure with the spaces
    return JSON.stringify(result,undefined,2)
  }
}

class InfoAlert extends Alert {
  constructor(message,timeout = -1) {
    super(message,"info",timeout);
  }
}

class SuccessAlert extends Alert {
  constructor(message,timeout = -1) {
    super(message,"success",timeout);
  }
}

class ErrorAlert extends Alert {
  constructor(message,timeout = -1) {
    super(message,"error",timeout);
  }
}

class WarningAlert extends Alert {
  constructor(message,timeout = -1) {
    super(message,"warning",timeout);
  }
}


export {
  Alert,
  NetworkErrorAlert,
  InfoAlert,
  SuccessAlert,
  ErrorAlert,
  WarningAlert
};